<template>
  <el-main class="materialwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>客户/供应商管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/pubcase' }">供应商刊例</el-breadcrumb-item>
        <el-breadcrumb-item>刊例模拟</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="base1">
      <h3 class="ntitle">预算模拟</h3>
      <div class="simform">
        <el-table :data="itemList" style="width: 100%;"
          :header-cell-style="{ background: '#fff!important', color: '#333!important' }" class="no-border-table">
          <el-table-column prop="vendor_id" label="供应商名称" header-align="center" align="center" min-width="150">
            <template slot-scope="scope">
              <el-select ref="vVendor" placeholder="请选择" v-model="scope.row.vendor_id"
                @blur="handleEdit(scope, 'vVendor')" @change="v => changeData(v, scope, 'vVendor')" filterable
                clearable>
                <el-option :label="v.vendor" :value="v.id" v-for="(v, i) in vendorList"
                  :key="`vendor_${i}`"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="category" label="类型" header-align="center" align="center" min-width="120">
            <template slot-scope="scope">
              <el-cascader ref="cateIdArray" v-model="scope.row.cate_id_array" :options="scope.row.selectTypeList"
                :props="{ expandTrigger: 'hover', checkStrictly: false }" @blur="handleEdit(scope, 'cateIdArray')"
                @change="v => changeData(v, scope, 'cateIdArray')"></el-cascader>
            </template>
          </el-table-column>
          <el-table-column prop="card_desc" label="描述" header-align="center" align="center" min-width="160">
            <template slot-scope="scope">
              <el-select ref="cardDesc" placeholder="请选择" v-model="scope.row.card_desc"
                @blur="handleEdit(scope, 'cardDesc')" @change="v => changeData(v, scope, 'cardDesc')" filterable>
                <el-option :label="v.card_desc" :value="v.card_desc" v-for="(v, i) in scope.row.descList"
                  :key="`desc_${i}`"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="单价（元）" header-align="center" align="center" min-width="80">
            <template slot-scope="scope">
              <div class="inner">{{ scope.row.price }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="unit" label="单位" header-align="center" align="center" min-width="80">
            <template slot-scope="scope">
              <div class="inner">{{ scope.row.unit }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="number" label="数量" header-align="center" align="center" min-width="80">
            <template slot-scope="scope">
              <!-- <div class="count">
                <div class="count-button add" @click="changeNum(scope, '1')"><i class="el-icon-plus"></i></div>
                <div class="count-input">
                  <el-input ref="vNum" @input="v => numLimit(v, scope)" maxlength="100" v-model="scope.row.number" />
                </div>
                <div class="count-button minus" @click="changeNum(scope, '2')"><i class="el-icon-minus"></i></div>
              </div> -->
              <el-input-number v-model="scope.row.number" @change="v => numLimit(v, scope)" :min="1"
                label="数量"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="" label="操作" header-align="center" align="center" width="150" fixed="right">
            <template slot-scope="scope">
              <div class="linkwrap">
                <el-link type='primary' class="link" @click="showDelete(scope)"><i
                    class="el-icon-delete"></i>删除</el-link>
                <el-link type='primary' class="link" @click="viewClick(scope)">推荐同类型</el-link>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="total-count">
          <div class="total-count-num">{{ ' 小计：' + getTotalCount() }}</div>
        </div>
        <div class="add">
          <el-button @click="addFn"><i class="el-icon-circle-plus" style="margin-right: 10px;"></i>新增</el-button>
        </div>
      </div>
    </div>

    <div class="base2">
      <h3 class="ntitle">相关推荐</h3>
      <div class="recom">
        <div class="recomm" v-if="recomList.length">
          <ul>
            <li v-for="(v, i) in recomList" :key="`recom_${i}`">
              <p>
                <label>供应商名称：</label><a>{{ v.vendor_name }}</a>
              </p>
              <p>
                <label>类型：</label><a>{{ v.category_type }}</a>
              </p>
              <p>
                <label>单价：</label><a>{{ v.price }}</a>
              </p>
              <p>
                <label>单位：</label><a>{{ v.unit }}</a>
              </p>
              <p>
                <label>描述：</label><a>
                  <pre style="margin: 0; font: 14px/3 arial;">{{ v.card_desc }}</pre>
                </a>
              </p>
              <p>
                <label>备注：</label><a>
                  <pre style="margin: 0; font: 14px/3 arial;">{{ v.card_remarks }}</pre>
                </a>
              </p>
              <div class="add-button">
                <el-button type="primary" class="el-icon-plus" @click="addToSim(v)">添加到模拟</el-button>
              </div>
            </li>
          </ul>

        </div>
        <div class="empty" v-else><el-empty description="暂无推荐"></el-empty></div>
      </div>
    </div>

    <el-dialog title="删除" :visible.sync="deleteShow" width="500px">
      <ul class="aul" style="padding:0">
        <li>
          <label>温馨提示：</label>
          <span>是否确认删除</span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteShow = false">取 消</el-button>
        <el-button type="primary" @click="handleDelete()">确 定</el-button>
      </span>
    </el-dialog>
  </el-main>
</template>

<script>
import * as api from '@/api'
import store from '@/store'
import { thousands, antiThousands } from "@/utils/index.js";
export default {
  name: 'pubcaseSim',
  data() {
    return {
      nodeLimtList: [],
      form: {},
      p: 1,
      perPage: 30,
      rules: {},
      itemList: [],
      unitList: [],
      // selectTypeList: [],
      deleteShow: false,
      deleteForm: {
        index: '',
      },
      del_detail_list: [],
      totalCount: 0,
      recomList: [],
    }
  },
  created() {
    this.getVendorList().then((res) => {
      this.vendorList = res
      console.log(res);
      this.getStoreFn()
    })
  },
  mounted() {

  },
  watch: {

  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分
      const hash = window.location.hash;
      // 移除'#'字符
      const url = hash.substring(1);

      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    getStoreFn() {
      let item = Object.keys(store.state.simData).length != 0 ? store.state.simData : {}
      if (Object.keys(item).length) {
        this.itemList.push(item)
      }
    },
    getVendorList() {
      const that = this;
      return new Promise(function (resolve) {
        that.$fly.post("apiPurchase_getVendorList.html", {
          per_page: 5000,
        }).then((res) => {
          const vendorList = res.itemList
          resolve(vendorList)
        });
      })
    },
    getSelectType(vid, cid) {
      const that = this;
      return new Promise(function (resolve) {
        that.$fly.post("ApiVendorCard_selectTypeList.html", {
          vendor_id: vid,
          cate_id: cid
        }).then((res) => {
          const selectTypeList = res.length ? res : [];
          resolve(selectTypeList)
        });
      })
    },
    getCardInfoToVendorAndCate(vid, cid, desc) {
      const that = this;
      return new Promise(function (resolve) {
        that.$fly.post("ApiVendorCard_getCardInfoToVendorAndCate.html", {
          vendor_id: vid,
          cate_id: cid,
          card_desc: desc,
        }).then((res) => {
          const cardInfo = res
          resolve(cardInfo)
        });
      })
    },
    handleEdit({ row }, ref) {
      //隐藏文本框
      setTimeout(() => {
        this.$set(row, `${ref}Flag`, false);
      }, 100); // 延迟 100ms 执行
    },
    changeData(value, { row, column }, ref) {
      //该方法调用修改的接口进行修改
      if (column.label == "供应商名称") {
        this.$set(row, `cate_id`, '')
        this.$set(row, `cate_id_array`, [])
        this.$set(row, `descList`, [])
        this.$set(row, `price`, '')
        this.$set(row, `unit`, '')
        // this.$set(row, `number`, 1)
        this.getSelectType(value).then(res => {
          this.$set(row, `selectTypeList`, res);
        })
      }
      if (column.label == "类型") {
        const trueId = value[value.length - 1]
        this.$set(row, `cate_id`, trueId)
        this.$set(row, `price`, '');
        this.$set(row, `unit`, '')
        this.$set(row, `card_desc`, '');
        this.getSelectType(row.vendor_id, trueId).then(res => {
          this.$set(row, `descList`, res)
          // this.$set(row, `number`, 1)
        })
      }
      if (column.label == "描述") {
        this.getCardInfoToVendorAndCate(row.vendor_id, row.cate_id, value).then(res => {
          this.$set(row, `price`, res.price)
          this.$set(row, `unit`, res.unit)
          // this.$set(row, `number`, 1)
        })
      }
      if (ref) {
        this.$set(row, `${ref}Flag`, false);
      }
    },
    //点击添加
    addFn() {
      const item = { id: '0', cate_id: '', cate_id_array: [], card_desc: '', price: '', unit: '', number: 1, }
      this.itemList.push(item)
      this.$forceUpdate()
    },
    showDelete({ row }) {
      const index = this.itemList.indexOf(row)
      this.deleteForm.index = index
      this.deleteShow = true
    },
    //点击删除
    handleDelete() {
      const _index = this.deleteForm.index
      console.log(_index);
      this.del_detail_list.push(this.itemList[_index].id);
      console.log(this.del_detail_list);
      this.itemList.splice(_index, 1)
      this.deleteShow = false
    },
    //用来取escader的值
    getCascaderValues(cate_id_array, options) {
      // try { } catch (error) { console.error('解析 JSON 失败:', error); return []; }
      const ids = cate_id_array;
      const result = [];
      let currentOptions = options;
      for (const id of ids) {
        const found = currentOptions.find(option => option.value === id);
        if (found) {
          result.push(found.label);
          if (found.children) {
            currentOptions = found.children;
          }
        } else {
          break;
        }
      }
      return result.join('/');
    },
    numLimit(v, { row }) {
      // 使用正则表达式限制输入内容
      const filteredValue = parseInt(String(v).replace(/[^\d]/g, '').slice(0, 4));
      // 更新绑定的值
      this.$set(row, `number`, filteredValue);
    },
    changeNum({ row }, flag) {
      let num = parseInt(row.number)
      if (flag == '1') {
        num++;
      } else {
        num--
      }
      this.$set(row, `number`, num);
    },
    getTotalCount() {
      let total = 0
      const arr = this.itemList
      for (let i = 0; i < arr.length; i++) {
        const price = arr[i].price;
        const num = arr[i].number;
        total += antiThousands(price) * num
      }
      return `￥${thousands(total)}`
    },
    viewClick({ row }) {
      if (!row.cate_id) {
        this.$message.error('请先选择类型！');
        return false;
      }
      this.recomList = []
      const cid = row.cate_id
      this.$fly.post("ApiVendorCard_getContrastInfo.html", {
        cate_id: cid
      }).then((res) => {
        this.recomList = res.length ? res : [];
        this.recomList = this.recomList.map(item => {
          item.category_type = this.getCategory(item.category, 'category_name')
          return item
        })
      });
    },
    getCategory(array, param) {
      // 检查输入是否有效
      if (!Array.isArray(array) || typeof param !== "string") {
        console.log("输入无效: array 必须是数组, param 必须是字符串");
      }
      // 提取每个对象中指定参数的值，并拼接成字符串
      const result = array.map((item) => item[param] || "").join("/"); // 用空格拼接所有值
      return result;
    },
    addToSim(item) {
      const {vendor_id, cate_id, card_desc, price, unit, cateInfo} = item
      let newItem = { id: '0', vendor_id, cate_id, cate_id_array: JSON.parse(cateInfo.cate_id_json), card_desc, price, unit, number: 1, }
      this.getSelectType(vendor_id).then(res => {
        newItem.selectTypeList = res
        this.itemList.push(newItem)
        this.$forceUpdate()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.materialwrap {
  .form.myform {
    padding-left: 100px;
  }

  .filterwrap {
    display: flex;
    justify-content: flex-end;
    padding: 0 0 15px 0;

    .el-button {
      margin: 0 0 0 20px;
    }
  }

  .base1 {
    @extend %box;
    margin-bottom: 20px;
    padding: 20px 40px;

    ul {
      padding: 0 25px 0 25px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-flow: row nowrap;
      color: var(--text-1); /* 0819修改 */;
      border-radius: 20px;
      background: var(--bg-soft); /* 0819修改 */
      margin-bottom: 20px;
      position: relative;

      li {
        width: 50%;
        font: 14px/3 $font;

        p {
          min-height: 42px;
          padding: 5px 0;
          @extend %start;

          a {
            cursor: default;
          }

          .bbox {
            width: 100%;
            padding: 0;
            display: block;

            li {
              width: 100%;
              height: 42px;

              &:last-child {
                width: 100%;
                padding-left: 0;
              }
            }
          }

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }
        }
      }
    }
  }

  .base2 {
    @extend %box;
    margin-bottom: 20px;
    padding: 20px 40px;

    .recom {
      padding: 25px;
      color: var(--text-1); /* 0819修改 */;
      border-radius: 20px;
      background: var(--bg-soft); /* 0819修改 */

      .recomm {
        width: 100%;
        overflow-x: auto;

        ul {
          display: flex;
          flex-flow: nowrap;
          padding: 0;
          margin: 0;
          list-style: none;

          li {
            flex: 0 0 auto;
            /* 禁止 flex 子项伸缩 */
            width: 450px;
            margin: 0 16px 8px 0;
            padding: 10px 10px 60px 10px;
            background: var(--card); /* 0819修改 */
            border-radius: 5px;
            box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
            font: 14px/3 $font;
            position: relative;

            p {
              min-height: 42px;
              padding: 5px 0;
              margin: 0 0 8px 0;
              @extend %start;

              label {
                width: 100px;
              }
            }
            
            .add-button {
              position: absolute;
              right: 20px;
              bottom: 15px;
            }
          }
        }
      }
    }
  }

  .inner {
    display: block;
    min-height: 23px;

    span {
      margin-right: 10px;
      font-size: 12px;
      display: inline-block;
      max-width: 200px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      cursor: pointer;

      &.a-remind {
        font-size: 16px;
        cursor: pointer;
      }
    }
  }

  // .count {
  //   display: flex;
  //   flex-flow: row nowrap;
  //   justify-content: space-between;
  //   align-items: center;

  //   .count-button {
  //     width: 32px;
  //     height: 32px;
  //     padding: 0;
  //     position: relative;
  //     cursor: pointer;

  //     &:hover {
  //       background: #e1e1e1;
  //     }

  //     i {
  //       position: absolute;
  //       left: 50%;
  //       top: 50%;
  //       transform: translate(-50%, -50%);
  //     }
  //   }

  //   .count-input {
  //     width: 100px;
  //   }
  // }

  .total-count {
    width: 100%;
    // border-top: 2px solid #333;
    margin-top: 20px;
    text-align: right;
    font: 18px/36px $font;

    .total-count-num {
      padding: 5px 40px;
    }
  }

  .add {
    padding: 20px 0 0;
  }

}
</style>
<style scoped>
.no-border-table>>>.el-table__row td {
  border-bottom: none;
  /* 去掉单元格的下边框 */
}

.no-border-table>>>.el-table__header th {
  border-bottom: none;
  /* 去掉表头的下边框 */
}

.no-border-table>>>.el-table__body {
  border-collapse: separate;
  /* 防止边框重叠 */
  border-spacing: 0;
  /* 去掉单元格之间的间距 */
}
</style>